/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Branches_Show_ArchivedInputs */

const en_branches_show_archived = /** @type {(inputs: Branches_Show_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show archived`)
};

const pt_br2_branches_show_archived = /** @type {(inputs: Branches_Show_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar arquivadas`)
};

/**
* | output |
* | --- |
* | "Show archived" |
*
* @param {Branches_Show_ArchivedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const branches_show_archived = /** @type {((inputs?: Branches_Show_ArchivedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Branches_Show_ArchivedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_branches_show_archived(inputs)
	return pt_br2_branches_show_archived(inputs)
});